export default {
  lineNumberColor: `#f8f8f8`,
  lineNumberBgColor: `#000`,
  backgroundColor: `#000`,
  textColor: `#f8f8f8`,
  substringColor: `#daefa3`,
  keywordColor: `#e28964`,
  attributeColor: `#cda869`,
  selectorAttributeColor: `#e28964`,
  docTagColor: undefined,
  nameColor: `#89bdff`,
  builtInColor: `#f8f8f8`,
  literalColor: `#f8f8f8`,
  bulletColor: `#3387cc`,
  codeColor: `#f8f8f8`,
  additionColor: `#f8f8f8`,
  regexpColor: `#e9c062`,
  symbolColor: `#3387cc`,
  variableColor: `#3e87e3`,
  templateVariableColor: `#3e87e3`,
  linkColor: `#e9c062`,
  selectorClassColor: `#9b703f`,
  typeColor: `#e28964`,
  stringColor: `#65b042`,
  selectorIdColor: `#8b98ab`,
  quoteColor: `#aeaeae`,
  templateTagColor: `#f8f8f8`,
  deletionColor: `#f8f8f8`,
  titleColor: `#89bdff`,
  sectionColor: `#89bdff`,
  commentColor: `#aeaeae`,
  metaKeywordColor: `#f8f8f8`,
  metaColor: `#8996a8`,
  functionColor: `#f8f8f8`,
  numberColor: `#3387cc`,
}
